<template>

    <div class="timer">
        <radial
            :completed-steps="completed"
            :total-steps="time"
            start-color="#B71E3F"
            stop-color="#B71E3F"
            :stroke-width="2"
            :indicator-size="12"
            inner-stroke-color="#fff"

        >
        </radial>
        <h2>Die Zeit läuft</h2>
        <p class="time">{{showTime}}</p>
    </div>
</template>
<style scoped>
    h2 {
        transform: rotate(-11deg);
        position: absolute;
        left: 12px;
        width: 200px;
        top: 40px;
    }
    p.time {
        font-size: 36px;
        text-align: center;

    }
</style>

<script>
    import Radial from "./Radial";

    export default {
        components: {Radial},
        props: ['time'],
        data() {
            return {
                remainingTime: 0
            }
        },
        created() {
            this.remainingTime = this.time;
            let interval = setInterval(() => {
                if (this.remainingTime<=0) {
                    this.$emit('done');
                    this.remainingTime=0;
                    clearInterval(interval);
                }
                this.remainingTime-=.1;
            }, 100);
        },
        computed: {
            completed() {
                return this.time - this.remainingTime + 1;
            },
            showTime() {
                let tenthSeconds = Math.ceil(this.remainingTime*10);
                if (this.remainingTime<10) {
                    return '0:0' + Math.ceil(this.remainingTime);
                }
                return '0:'+Math.ceil(this.remainingTime);

                if (tenthSeconds%10) {
                    return (tenthSeconds/10+'').replace('.',',') + '0';
                }
                return (tenthSeconds/10+'') + ',00';
            }
        }

    }
</script>



// WEBPACK FOOTER //
// src/components/Timer.vue